import { errorMsg } from '../constants/messages';

const locationFormData = [
  {
    name: 'name',
    label: 'Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Name', enableSort: false, allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'locationType',
    label: 'Location Type',
    fieldType: {
      name: 'select',
      options: [],
    },
    placeholder: 'Click here to select an Location Type',
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Location Type',
      enableSort: false,
      allowAddRecordClick: false,
      columnType: 'displayName',
    },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    readonly: false,
  },
];

export { locationFormData };
